export const VITE_OTP_GATEWAY_URL = import.meta.env.VITE_OTP_GATEWAY_URL;
export const VITE_ZEM_GATEWAY_URL = import.meta.env.VITE_ZEM_GATEWAY_URL;
export const VITE_API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const LOAN_PURPOSE_PERSONAL = "Personal";
export const LOAN_PURPOSE_BUSINESS = "Business";
export const LOAN_PURPOSE_NOVATED_LEASE = "Novated Lease";
export const LOAN_PURPOSE_DEBT_CONSOLIDATION = "Debt Consolidation";
export const LOAN_PURPOSE_OTHER = "Other";
export const EMP_STAT_SELF_EMPLOYED = "Self-employed";
export const ABN_STATUS_NEW_ABN = "New Business ABN";
export const BOAT_ASSET_TYPE_COMMERCIAL = "Commercial Boat";

// Fix my credit
export const FMC_FORM_TITLE = "How can we reach you?";
export const FIX_MY_CREDIT_NAME = "Fix My Credit";
export const FIX_MY_CREDIT_REF_ID = "7074";
export const FIX_MY_CREDIT_EMAIL = "info@fixmycred.com.au";

// Email typos
export const emailTypos: Record<string, string> = {
	// GMAIL
	"gamil.com": "gmail.com",
	"gmal.com": "gmail.com",
	"gmaill.com": "gmail.com",
	"gmial.com": "gmail.com",
	"gmaii.com": "gmail.com",
	"gamil.com.au": "gmail.com.au",
	"gmail.con": "gmail.com",
	"gmail.con.au": "gmail.com.au",
	"gamail.com": "gmail.com",

	// OUTLOOK
	"outlook.con": "outlook.com",
	"outlok.com": "outlook.com",
	"outllok.com": "outlook.com",
	"outlook.con.au": "outlook.com.au",

	// YAHOO
	"yaho.com": "yahoo.com",
	"yaboo.com.au": "yahoo.com.au",
	"yahoo.con.au": "yahoo.com.au",
	"yaho.com.au": "yahoo.com.au",
	"yahoo.con": "yahoo.com",
	"yhoo.com": "yahoo.com",

	// HOTMAIL
	"htmail.com": "hotmail.com",
	"hotmail.con": "hotmail.com",
	"hotmial.com": "hotmail.com",
	"hotmail.con.au": "hotmail.com.au",

	// ICLOUD / BIGPOND
	"icloud.con": "icloud.com",
	"iclou.com": "icloud.com",
	"bigpond.con": "bigpond.com",
	"bigpond.com.au": "bigpond.com",
	"bigpond.con.au": "bigpond.com",
};

// Initialised loan types
export const ALL_LOAN_TYPES =
	"Equipment Loan,Business Loan,Livestock Loan,Agri Property Loan,Home Loan,Other";
export const LOAN_TYPE_PERSONAL = "Personal Loan";
export const LOAN_TYPE_CAR = "Car Loan";
export const LOAN_TYPE_BOAT = "Boat Loan";
export const LOAN_TYPE_BIKE = "Bike Loan";
export const LOAN_TYPE_MOTORCYCLE = "Motorcycle Loan";
export const LOAN_TYPE_CARAVAN = "Caravan Loan";
export const LOAN_TYPE_TRUCK = "Truck Loan";
export const LOAN_TYPE_EQUIPMENT = "Equipment Loan";
export const LOAN_TYPE_BUSINESS = "Business Loan";
export const LOAN_TYPE_LIVESTOCK = "Livestock Loan";
export const LOAN_TYPE_AGRI_PROPERTY = "Agri Property Loan";
export const LOAN_TYPE_HOME = "Home Loan";
export const LOAN_TYPE_OTHER = "Other";

// Mortgage Loan Purpose
export const LOAN_PURPOSE_MORTGAGE_BUILD = "Build a Home";
export const LOAN_PURPOSE_MORTGAGE_REFINANCE = "Refinance Existing Home Loan";
export const LOAN_PURPOSE_MORTGAGE_INVESTMENT = "Purchase an Investment Property";
export const LOAN_PURPOSE_MORTGAGE_OCCUPY = "Buy a Home to Live In";

// Property Type
export const PROPERTY_TYPE_NEW = "Newly Built Home";
export const PROPERTY_TYPE_EXISTING = "Existing Home";
export const PROPERTY_TYPE_LAND = "Land";
export const PROPERTY_TYPE_OFF_THE_PLAN = "Off-the-Plan Home";

// Assets used in partner pages
export const ASSET_TYPE_CAR = "Cars";
export const ASSET_TYPE_CARAVAN = "Caravans";
export const ASSET_TYPE_TRUCK = "Trucks";
export const ASSET_TYPE_EQUIPMENT = "Equipment";
export const ASSET_TYPE_BEAUTY = "Beauty Equipment";
export const ASSET_TYPE_BIKE = "Bikes";
export const ASSET_TYPE_BOAT = "Boats";
export const ASSET_TYPE_PERSONAL = "Personal";
export const LOANTYPES_WLOANPURPOSE = [ASSET_TYPE_CAR, ASSET_TYPE_BOAT];

export const callDays = [
	{
		option: "Any",
		value: "Any",
		id: 0,
	},
	{
		option: "Monday",
		value: "Monday",
		id: 1,
	},
	{
		option: "Tuesday",
		value: "Tuesday",
		id: 2,
	},
	{
		option: "Wednesday",
		value: "Wednesday",
		id: 3,
	},
	{
		option: "Thursday",
		value: "Thursday",
		id: 4,
	},
	{
		option: "Friday",
		value: "Friday",
		id: 5,
	},
	{
		option: "Saturday",
		value: "Saturday",
		id: 6,
	},
	{
		option: "Sunday",
		value: "Sunday",
		id: 7,
	},
];

export const stateOption = [
	{
		option: "Please choose a state...",
		value: "",
	},
	{
		option: "QLD",
		value: "QLD",
	},
	{
		option: "NSW",
		value: "NSW",
	},
	{
		option: "SA",
		value: "SA",
	},
	{
		option: "NT",
		value: "NT",
	},
	{
		option: "WA",
		value: "WA",
	},
	{
		option: "TAS",
		value: "TAS",
	},
	{
		option: "ACT",
		value: "ACT",
	},
	{
		option: "VIC",
		value: "VIC",
	},
];

export const loan_type = [
	{
		option: "Car Loan",
		id: 1,
		value: "Car Loan",
	},
	{
		option: "Boat Loan",
		id: 2,
		value: "Boat Loan",
	},
	{
		option: "Truck Loan",
		id: 8,
		value: "Truck Loan",
	},
	{
		option: "Equipment Loan",
		id: 6,
		value: "Equipment Loan",
	},
	{
		option: "Caravan Loan",
		id: 4,
		value: "Caravan Loan",
	},
	{
		option: "Motorcycle Loan",
		id: 3,
		value: "Motorcycle Loan",
	},
	{
		option: "Personal Loan",
		id: 5,
		value: "Personal Loan",
	},
	{
		option: "Business Loan",
		id: 5,
		value: "Business Loan",
	},
	{
		option: "Livestock Loan",
		id: 5,
		value: "Livestock Loan",
	},
	{
		option: "Agri Property Loan",
		id: 5,
		value: "Agri Property Loan",
	},
	{
		option: "Home Loan",
		id: 5,
		value: "Home Loan",
	},
	{
		option: "Other",
		id: 5,
		value: "Other",
	},
];

export const loan_purpose = [
	{
		option: "Personal",
		id: 1,
		value: "Personal",
	},
	{
		option: "Business",
		id: 2,
		value: "Business",
	},
];

export const car_loan_purpose = [
	{
		option: "Personal",
		id: 1,
		value: "Personal",
	},
	{
		option: "Business",
		id: 2,
		value: "Business",
	},
	{
		option: "Novated Lease",
		id: 1,
		value: "Novated Lease",
	},
];

export const boat_asset_type = [
	{
		option: "Boat",
		value: "Boat",
	},
	{
		option: "Jet Ski / PWC",
		value: "Jet Ski / PWC",
	},
	{
		option: "Sailboat / Yacht",
		value: "Sailboat / Yacht",
	},
	{
		option: "Commercial Boat",
		value: "Commercial Boat",
	},
	{
		option: "Houseboat",
		value: "Houseboat",
	},
];

export const equipment_asset_type = [
	{
		option: "Assets",
		value: "Assets",
	},
	{
		option: "Vehicle",
		value: "Vehicle",
	},
	{
		option: "Cashflow",
		value: "Cashflow",
	},
	{
		option: "General",
		value: "General",
	},
];

export const personal_loan_purpose = [
	{
		option: LOAN_PURPOSE_DEBT_CONSOLIDATION,
		value: LOAN_PURPOSE_DEBT_CONSOLIDATION,
	},
	{
		option: LOAN_PURPOSE_OTHER,
		value: LOAN_PURPOSE_OTHER,
	},
];

export const purchase_stage = [
	{
		option: "Actively Looking",
		value: "Actively Looking",
	},
	{
		option: "Found One - Ready to Finance",
		value: "Found One - Ready to Finance",
	},
	{
		option: "Just Browsing",
		value: "Just Browsing",
	},
];

export const asset_age = [
	{
		option: "Brand New / Demo",
		value: "Brand New / Demo",
	},
	{
		option: "Used",
		value: "Used",
	},
	{
		option: "Refinance Existing",
		value: "Refinance Existing",
	},
	{
		option: "Not Sure Yet",
		value: "Not Sure Yet",
	},
];

export const purchase_from = [
	{
		option: "Dealer",
		value: "Dealer",
	},
	{
		option: "Auction",
		value: "Auction",
	},
	{
		option: "Private Seller",
		value: "Private Seller",
	},
	{
		option: "Not Sure Yet",
		value: "Not Sure Yet",
	},
];

export const living_status = [
	{
		option: "Please select...",
		id: null,
		value: "",
	},
	{
		option: "Home Owner - With Mortgage",
		id: 1,
		value: "Home Owner - With Mortgage",
	},
	{
		option: "Home Owner - No Mortgage",
		id: 2,
		value: "Home Owner - No Mortgage",
	},
	{
		option: "Renting",
		id: 3,
		value: "Renting",
	},
	{
		option: "Boarding",
		id: 6,
		value: "Boarding",
	},
	{
		option: "Living with Family",
		id: 4,
		value: "Living with Family",
	},
	{
		option: "Other",
		id: 10,
		value: "Other",
	},
];

export const employment_status = [
	{
		option: "Please select...",
		id: null,
		value: "",
	},
	{
		option: "Full time",
		id: 1,
		value: "Full time",
	},
	{
		option: "Part time",
		id: 2,
		value: "Part time",
	},
	{
		option: "Casual",
		id: 3,
		value: "Casual",
	},
	{
		option: "Self-employed",
		id: 4,
		value: "Self-employed",
	},
	{
		option: "Contractor",
		id: 11,
		value: "Contractor",
	},
	{
		option: "Retired",
		id: 9,
		value: "Retired",
	},
	{
		option: "Self-funded Retiree",
		id: 10,
		value: "Self-funded Retiree",
	},
	{
		option: "Not currently employed",
		id: 8,
		value: "Not currently employed",
	},
	{
		option: "Governments Benefits",
		id: 7,
		value: "Governments Benefits",
	},
];

export const credit_history = [
	{
		option: "Please select...",
		value: "",
	},
	{
		option: "Perfect Credit History",
		value: "Perfect Credit History",
	},
	{
		option: "Comparable Credit History",
		value: "Comparable Credit History",
	},
	{
		option: "Poor Credit History",
		value: "Poor Credit History",
	},
	{
		option: "Paid Defaults",
		value: "Paid Defaults",
	},
	{
		option: "Un-Paid Defaults",
		value: "Un-Paid Defaults",
	},
	{
		option: "Ex Bankrupt",
		value: "Ex Bankrupt",
	},
	{
		option: "First Time Loan",
		value: "First Time Loan",
	},
	{
		option: "I'm not sure",
		value: "I'm not sure",
	},
];

export const abn_status = [
	{
		option: "Please select...",
		value: "",
	},
	{
		option: "New Business ABN",
		value: "New Business ABN",
	},
	{
		option: "Less than 1 Year",
		value: "Less than 1 Year",
	},
	{
		option: "More than 1 Year",
		value: "More than 1 Year",
	},
];

export const gst_status = [
	{
		option: "Please select...",
		value: "",
	},
	{
		option: "Not registered for GST",
		value: "Not registered for GST",
	},
	{
		option: "6 Months +",
		value: "6 Months +",
	},
	{
		option: "12 Months +",
		value: "12 Months +",
	},
];

// Business Loan
export const LOAN_PURPOSE_WORKING_CAPITAL = "Working Capital/Cash Flow";
export const LOAN_PURPOSE_BUSINESS_VEHICLE = "Business Vehicle Finance";
export const LOAN_PURPOSE_TRUCK = "Truck Finance";
export const LOAN_PURPOSE_EQUIPMENT = "Equipment Finance";

export const ABN_STATUS_REGISTERED = "I already have a registered ABN";
export const ABN_STATUS_UNREGISTERED = "I don't have a registered ABN yet";

export const business_abn_status = [
	{
		option: "Please select...",
		value: "",
	},
	{
		option: "I already have a registered ABN",
		value: "I already have a registered ABN",
	},
	{
		option: "I don't have a registered ABN yet",
		value: "I don't have a registered ABN yet",
	},
];

export const abn_years = Array.from({ length: 20 }, (_, i) => {
	const value = i + 1;
	return `${value} year${value > 1 ? "s" : ""}`;
});

export const abn_months = Array.from({ length: 12 }, (_, i) => {
	return `${i} month${i !== 1 ? "s" : ""}`;
});

export const trustee_classification = [
	{
		option: "Individual/Sole Trader",
		value: "Individual/Sole Trader",
	},
	{
		option: "Private Company",
		value: "Private Company",
	},
	{
		option: "Family Partnership",
		value: "Family Partnership",
	},
	{
		option: "Limited Partnership",
		value: "Limited Partnership",
	},
	{
		option: "Discretionary Investment Trust",
		value: "Discretionary Investment Trust",
	},
	{
		option: "Discretionary Trading Trust",
		value: "Discretionary Trading Trust",
	},
	{
		option: "Co-operative",
		value: "Co-operative",
	},
	{
		option: "Fixed Unit Trust",
		value: "Fixed Unit Trust",
	},
	{
		option: "Fixed Trust",
		value: "Fixed Trust",
	},
	{
		option: "Hybrid Trust",
		value: "Hybrid Trust",
	},
	{
		option: "Super Fund",
		value: "Super Fund",
	},
	{
		option: "Cash Management Trust",
		value: "Cash Management Trust",
	},
	{
		option: "Discretionary Services Management Trust",
		value: "Discretionary Services Management Trust",
	},
	{
		option: "Public Company",
		value: "Public Company",
	},
	{
		option: "Corporate Unit Trust",
		value: "Corporate Unit Trust",
	},
	{
		option: "Pooled Development Fund",
		value: "Pooled Development Fund",
	},
	{
		option: "Pooled Superannuation",
		value: "Pooled Superannuation",
	},
	{
		option: "Public Trading Trust",
		value: "Public Trading Trust",
	},
	{
		option: "Strata-title",
		value: "Strata-title",
	},
	{
		option: "Unlisted Public Unit Trust",
		value: "Unlisted Public Unit Trust",
	},
	{
		option: "Listed Public Unit Trust",
		value: "Listed Public Unit Trust",
	},
	{
		option: "Approved Deposit Fund",
		value: "Approved Deposit Fund",
	},
	{
		option: "Other Incorporated Entity",
		value: "Other Incorporated Entity",
	},
	{
		option: "Other Partnership",
		value: "Other Partnership",
	},
	{
		option: "Other Trust",
		value: "Other Trust",
	},
	{
		option: "Other Unincorporated Entity",
		value: "Other Unincorporated Entity",
	},
	{
		option: "ATO Regulated Self-Managed Superannuation Fund",
		value: "ATO Regulated Self-Managed Superannuation Fund",
	},
	{
		option: "First Home Saver Accounts Trust",
		value: "First Home Saver Accounts Trust",
	},
	{
		option: "Non-Regulated Superannuation Fund",
		value: "Non-Regulated Superannuation Fund",
	},
	{
		option: "Deceased Estate",
		value: "Deceased Estate",
	},
	{
		option: "LGA",
		value: "LGA",
	},
	{
		option: "Government Entity",
		value: "Government Entity",
	},
	{
		option: "State Government Entity",
		value: "State Government Entity",
	},
	{
		option: "APRA",
		value: "APRA",
	},
	{
		option: "Other",
		value: "Other",
	},
];

export const business_equipment_asset_type = [
	{
		option: "Farm Equipment",
		value: "Farm Equipment",
	},
	{
		option: "Heavy Equipment",
		value: "Heavy Equipment",
	},
	{
		option: "Manufacturing Equipment",
		value: "Manufacturing Equipment",
	},
	{
		option: "Hospitality Equipment",
		value: "Hospitality Equipment",
	},
	{
		option: "Fitness Equipment",
		value: "Fitness Equipment",
	},
	{
		option: "Medical Equipment",
		value: "Medical Equipment",
	},
	{
		option: "Dental Equipment",
		value: "Dental Equipment",
	},
	{
		option: "Low Doc Equipment Finance",
		value: "Low Doc Equipment Finance",
	},
	{
		option: "Other Equipment Finance",
		value: "Other Equipment Finance",
	},
];

export const business_truck_asset_type = [
	{
		option: "Heavy Truck",
		value: "Heavy Truck",
	},
	{
		option: "Light Truck",
		value: "Light Truck",
	},
	{
		option: "Cab Chassis Truck",
		value: "Cab Chassis Truck",
	},
	{
		option: "Curtainsider Truck",
		value: "Curtainsider Truck",
	},
	{
		option: "Pantech Truck",
		value: "Pantech Truck",
	},
	{
		option: "Prime Mover Truck",
		value: "Prime Mover Truck",
	},
	{
		option: "Crane Truck",
		value: "Crane Truck",
	},
	{
		option: "Tow Truck",
		value: "Tow Truck",
	},
	{
		option: "Concrete Truck",
		value: "Concrete Truck",
	},
	{
		option: "Tipper Truck",
		value: "Tipper Truck",
	},
	{
		option: "Tray Truck",
		value: "Tray Truck",
	},
	{
		option: "Other Truck",
		value: "Other Truck",
	},
];

export const equipment_finance_reason = [
	{
		option: "Owner Operator",
		value: "Owner Operator",
	},
	{
		option: "Purchase Additional Equipment",
		value: "Purchase Additional Equipment",
	},
	{
		option: "Replace Existing Equipment",
		value: "Replace Existing Equipment",
	},
	{
		option: "Refinance Existing Equipment",
		value: "Refinance Existing Equipment",
	},
	{
		option: "Add to Existing Equipment",
		value: "Add to Existing Equipment",
	},
	{
		option: "Other",
		value: "Other",
	},
];

export const business_loan_purpose = [
	{
		option: "Business Vehicle Finance",
		id: 1,
		value: "Business Vehicle Finance",
	},
	{
		option: "Working Capital/Cash Flow",
		id: 5,
		value: "Working Capital/Cash Flow",
	},
	{
		option: "Truck Finance",
		id: 8,
		value: "Truck Finance",
	},
	{
		option: "Equipment Finance",
		id: 6,
		value: "Equipment Finance",
	},
];

// Agriculture Consultation Form
export const day_options = [
	{
		option: "Any",
		value: "Any",
	},
	{
		option: "Monday",
		value: "Monday",
	},
	{
		option: "Tuesday",
		value: "Tuesday",
	},
	{
		option: "Wednesday",
		value: "Wednesday",
	},
	{
		option: "Thursday",
		value: "Thursday",
	},
	{
		option: "Friday",
		value: "Friday",
	},
	{
		option: "Saturday",
		value: "Saturday",
	},
	{
		option: "Sunday",
		value: "Sunday",
	},
];

export const agri_loan_types = [
	{
		option: "Equipment Loan",
		id: 6,
		value: "Equipment Loan",
	},
	{
		option: "Business Loan",
		id: 5,
		value: "Business Loan",
	},
	{
		option: "Livestock Loan",
		id: 5,
		value: "Livestock Loan",
	},
	{
		option: "Agri Property Loan",
		id: 5,
		value: "Agri Property Loan",
	},
	{
		option: "Home Loan",
		id: 5,
		value: "Home Loan",
	},
	{
		option: "Other",
		id: 5,
		value: "Other",
	},
];

// Fix my credit
export const credit_status = [
	{
		option: "Please select...",
		value: "",
	},
	{
		option: "Un-Paid Defaults",
		value: "Un-Paid Defaults",
	},
	{
		option: "Paid Defaults",
		value: "Paid Defaults",
	},
	{
		option: "Ex Bankrupt",
		value: "Ex Bankrupt",
	},
	{
		option: "Bankrupt Currently",
		value: "Bankrupt Currently",
	},
	{
		option: "Part 9 Debt Arrangement",
		value: "Part 9 Debt Arrangement",
	},
	{
		option: "Court Judgements Paid",
		value: "Court Judgements Paid",
	},
	{
		option: "Court Judgements Unpaid",
		value: "Court Judgements Unpaid",
	},
	{
		option: "Slow Payment Credit Reporting",
		value: "Slow Payment Credit Reporting",
	},
];

// Mortgage
export const loan_purpose_mortgage = [
	{
		option: "Buy a Home to Live In",
		id: 1,
		value: "Buy a Home to Live In",
	},
	{
		option: "Purchase an Investment Property",
		id: 2,
		value: "Purchase an Investment Property",
	},
	{
		option: LOAN_PURPOSE_MORTGAGE_REFINANCE,
		id: 3,
		value: LOAN_PURPOSE_MORTGAGE_REFINANCE,
	},
	{
		option: "Build a Home",
		id: 4,
		value: "Build a Home",
	},
];

export const property_type = [
	{
		option: PROPERTY_TYPE_NEW,
		id: 1,
		value: PROPERTY_TYPE_NEW,
	},
	{
		option: PROPERTY_TYPE_EXISTING,
		id: 2,
		value: PROPERTY_TYPE_EXISTING,
	},
	{
		option: PROPERTY_TYPE_LAND,
		id: 3,
		value: PROPERTY_TYPE_LAND,
	},
	{
		option: PROPERTY_TYPE_OFF_THE_PLAN,
		id: 4,
		value: PROPERTY_TYPE_OFF_THE_PLAN,
	},
];

export const refinance_purpose = [
	{
		option: "Decrease Payments",
		id: 1,
		value: "Decrease Payments",
	},
	{
		option: "Pay Off Loan Faster",
		id: 2,
		value: "Pay Off Loan Faster",
	},
	{
		option: "Consolidate Debt",
		id: 3,
		value: "Consolidate Debt",
	},
	{
		option: "Other",
		id: 4,
		value: "Other",
	},
];

export const yesNoOptions = [
	{
		option: "Yes",
		id: 1,
		value: "Yes",
	},
	{
		option: "No",
		id: 2,
		value: "No",
	},
];

export const loanFieldsMap: Record<string, Record<string, any[]>> = {
	"Car Loan": {
		loanPurpose: [...car_loan_purpose],
		purchaseStage: [...purchase_stage],
		assetType: [],
		assetAge: [...asset_age],
		purchaseFrom: [...purchase_from],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
	"Boat Loan": {
		loanPurpose: [...loan_purpose],
		purchaseStage: [...purchase_stage],
		assetType: [...boat_asset_type],
		assetAge: [...asset_age],
		purchaseFrom: [...purchase_from],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
	"Truck Loan": {
		loanPurpose: [loan_purpose[1]],
		purchaseStage: [...purchase_stage],
		assetType: [],
		assetAge: [...asset_age],
		purchaseFrom: [...purchase_from],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
	"Equipment Loan": {
		loanPurpose: [loan_purpose[1]],
		purchaseStage: [...purchase_stage],
		assetType: [...equipment_asset_type],
		assetAge: [...asset_age],
		purchaseFrom: [...purchase_from],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
	"Caravan Loan": {
		loanPurpose: [loan_purpose[0]],
		purchaseStage: [...purchase_stage],
		assetType: [],
		assetAge: [...asset_age],
		purchaseFrom: [...purchase_from],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [],
		gstStatus: [],
		creditHistory: [...credit_history],
	},
	"Motorcycle Loan": {
		loanPurpose: [loan_purpose[0]],
		purchaseStage: [...purchase_stage],
		assetType: [],
		assetAge: [...asset_age],
		purchaseFrom: [...purchase_from],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [],
		gstStatus: [],
		creditHistory: [...credit_history],
	},
	"Bike Loan": {
		loanPurpose: [loan_purpose[0]],
		purchaseStage: [...purchase_stage],
		assetType: [],
		assetAge: [...asset_age],
		purchaseFrom: [...purchase_from],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [],
		gstStatus: [],
		creditHistory: [...credit_history],
	},
	"Personal Loan": {
		loanPurpose: [...personal_loan_purpose],
		purchaseStage: [],
		assetType: [],
		assetAge: [],
		purchaseFrom: [],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [],
		gstStatus: [],
		creditHistory: [...credit_history],
	},
	"Business Loan": {
		loanPurpose: [...business_loan_purpose],
		livingStatus: [...living_status],
		employmentStatus: [],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
	"Agri Property Loan": {
		loanPurpose: [...loan_purpose_mortgage],
		assetType: [...property_type],
		purchaseStage: [...purchase_stage],
		isFirstHomeBuyer: [...yesNoOptions],
		refinancePurpose: [...refinance_purpose],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
	"Home Loan": {
		loanPurpose: [...loan_purpose_mortgage],
		assetType: [...property_type],
		purchaseStage: [...purchase_stage],
		isFirstHomeBuyer: [...yesNoOptions],
		refinancePurpose: [...refinance_purpose],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
	Other: {
		loanPurpose: [...loan_purpose],
		purchaseStage: [...purchase_stage],
		assetType: [],
		assetAge: [...asset_age],
		purchaseFrom: [...purchase_from],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
};

export const subLoanFieldsMap: Record<string, Record<string, any[]>> = {
	"Working Capital/Cash Flow": {
		businessAbnStatus: [...business_abn_status],
		purchaseStage: [],
		financeReason: [],
		assetType: [],
		assetAge: [],
		purchaseFrom: [],
	},
	"Business Vehicle Finance": {
		businessAbnStatus: [],
		purchaseStage: [...purchase_stage],
		financeReason: [],
		assetType: [],
		assetAge: [...asset_age],
		purchaseFrom: [...purchase_from],
	},
	"Truck Finance": {
		businessAbnStatus: [],
		purchaseStage: [...purchase_stage],
		financeReason: [],
		assetType: [...business_truck_asset_type],
		assetAge: [...asset_age],
		purchaseFrom: [...purchase_from],
	},
	"Equipment Finance": {
		businessAbnStatus: [],
		purchaseStage: [...purchase_stage],
		financeReason: [...equipment_finance_reason],
		assetType: [...business_equipment_asset_type],
		assetAge: [...asset_age],
		purchaseFrom: [...purchase_from],
	},
};

export const stepProcessMap: Record<string, Record<string, any>> = {
	// Default Steps for all Loan Types except Mortgage
	Default: [
		{
			id: 0,
			name: "Personal Details",
		},
		{
			id: 1,
			name: "Verification",
		},
		{
			id: 2,
			name: "Loan Details",
		},
		{
			id: 3,
			name: "Additional Information",
		},
		{
			id: 4,
			name: "Completed",
		},
	],
	// Steps for LOAN_TYPE_MORTGAGE Type
	"Mortgage Loan": [
		{
			id: 0,
			name: "Personal Details",
		},
		{
			id: 1,
			name: "Verification",
		},
		{
			id: 2,
			name: "Loan Purpose",
		},
		{
			id: 3,
			name: "Property Details",
		},
		{
			id: 4,
			name: "Additional Information",
		},
		{
			id: 5,
			name: "Completed",
		},
	],
	// Consultation Form Steps for Mobile Only
	Consultation: [
		{
			id: 0,
			name: "Availability",
		},
		{
			id: 1,
			name: "Finance Option",
		},
		{
			id: 2,
			name: "Personal Details",
		},
		{
			id: 3,
			name: "Completed",
		},
	],
};

// App theme settings
export const appSettingsConfig: Record<string, Record<string, string>> = {
	"Jade Agri Finance": {
		themeColor: "#19cc76",
		hoverColor: "#16ac6b",
		themeHeaderTxt: "#142f48",
		bulletBG: "#bbf7d0",
	},
	"Jade Finance": {
		themeColor: "#19cc76",
		hoverColor: "#16ac6b",
		themeHeaderTxt: "#142f48",
		bulletBG: "#bbf7d0",
	},
	"Jade Boat Loans": {
		themeColor: "#599bf8",
		hoverColor: "#457ac4",
		themeHeaderTxt: "#142f48",
		bulletBG: "#DBEAFE",
	},
	"Jade Car Loans": {
		themeColor: "#da1710",
		hoverColor: "#c51a14",
		themeHeaderTxt: "#142f48",
		bulletBG: "#FFC9C9",
	},
	"Jade Caravan Finance": {
		themeColor: "#FF7901",
		hoverColor: "#e46701",
		themeHeaderTxt: "#142f48",
		bulletBG: "#FFD6A7",
	},
	"Jade Equipment Finance": {
		themeColor: "#069f2e",
		hoverColor: "#068026",
		themeHeaderTxt: "#142f48",
		bulletBG: "#D0FAE5",
	},
	"Jade Truck Loans": {
		themeColor: "#ffc913",
		hoverColor: "#e9b814",
		themeHeaderTxt: "#142f48",
		bulletBG: "#FEF9C2",
	},
	"Jade Bike Loans": {
		themeColor: "#0e8fbe",
		hoverColor: "#0d7ea7",
		themeHeaderTxt: "#142f48",
		bulletBG: "#DFF2FE",
	},
};
